import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const STORE_URL = 'https://www.intiviv.com';

const RITUAL_STEPS = [
  { step: 1, act: 'Cleanse', name: 'Intimate Balance Cleanser', img: '/products/cleanser.webp', desc: 'pH-balanced gentle wash — the foundation of everyday intimate care.' },
  { step: 2, act: 'Refresh', name: 'Intimate Freshness Mist', img: '/products/mist.webp', desc: 'Instant freshness and odour control — post-workout, travel, anytime.' },
  { step: 3, act: 'Hydrate', name: 'Intimate Comfort Moisturizer', img: '/products/moisturizer.webp', desc: 'Hormone-free daily hydration for lasting comfort and care.' },
  { step: 4, act: 'Glide', name: 'Intimate Silk Lubricant', img: '/products/lubricant.webp', desc: 'Long-lasting, pH-balanced silkiness for smooth, comfortable intimacy.' },
  { step: 5, act: 'Connect', name: 'Sensual Intimate Oil', img: '/products/oil.webp', desc: 'Botanical massage oil for relaxation and deeper intimate connection.' },
];

const openStore = () => window.open(STORE_URL, '_blank', 'noopener,noreferrer');

export default function Ritual() {
  const navigate = useNavigate();

  return (
    <div className="ritual-shell" data-testid="ritual-page">
      <div className="education-aurora" aria-hidden="true" />

      {/* Header */}
      <div className="ritual-header">
        <button onClick={() => navigate('/home')} className="btn-ghost" style={{ padding: '6px 0', fontSize: '0.79rem', letterSpacing: '0.14em' }} data-testid="ritual-back">
          <i className="fa-solid fa-arrow-left" /> HOME
        </button>
        <div className="eyebrow" style={{ marginTop: 10 }}>Five steps · One daily devotion</div>
        <h1 className="ritual-title">The INTIVIV<sup>™</sup> <span className="gold-italic">Ritual</span></h1>
        <p className="ritual-sub">
          A gynaecologist-designed sequence of five essentials — cleanse, refresh, hydrate, glide, connect.
          Crafted for everyday intimate wellness.
        </p>
      </div>

      {/* Hero image */}
      <motion.div
        className="ritual-hero"
        initial={{ opacity: 0, y: 22 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onClick={openStore}
        role="button"
        data-testid="ritual-hero"
      >
        <img src="/products/ritual-hero.webp" alt="The INTIVIV Ritual — five products" />
        <div className="ritual-hero-badge"><i className="fa-solid fa-arrow-up-right-from-square" /> www.intiviv.com</div>
      </motion.div>

      {/* Steps */}
      <div className="ritual-steps">
        {RITUAL_STEPS.map((s, i) => (
          <motion.button
            key={s.step}
            className="ritual-step-card immersive-card"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-30px' }}
            transition={{ duration: 0.4, delay: i * 0.06 }}
            onClick={openStore}
            data-testid={`ritual-step-${s.step}`}
          >
            <div className="ritual-step-num">{s.step}</div>
            <div className="ritual-step-img">
              <img src={s.img} alt={s.name} loading="lazy" />
            </div>
            <div className="ritual-step-body">
              <div className="ritual-step-act">{s.act}</div>
              <div className="ritual-step-name">{s.name}</div>
              <div className="ritual-step-desc">{s.desc}</div>
            </div>
            <i className="fa-solid fa-arrow-up-right-from-square ritual-step-arrow" />
          </motion.button>
        ))}
      </div>

      {/* CTA */}
      <div className="ritual-cta">
        <button className="btn-gold" onClick={openStore} data-testid="ritual-shop-cta">
          <i className="fa-solid fa-bag-shopping" /> Shop the Ritual
        </button>
        <div className="ritual-cta-note">Dermatologically tested · Gynaecologist-led · www.intiviv.com</div>
      </div>
    </div>
  );
}
